import create from 'zustand'
import queryString from "query-string"
import translations from "api/translations.json"

const updateURL = config => (set, get, api) => config(args => {
    set(args)
    const { rotation, size, theme, table, ring, control, powerSupply } = get()
    // filter all null and undefined values
    const params = Object
        .entries({ rotation, size, theme, table, ring, control, powerSupply })
        // eslint-disable-next-line
        .reduce((a,[k,v]) => ((v == null || v == "") ? a : (a[k]=v, a)), {})
    // Update URL path with query params from state object
    var newRelativePathQuery = window.location.origin
        + window.location.pathname
        + "?" + queryString.stringify(params);

    window.history.replaceState(null, '', newRelativePathQuery);
  }, get, api)

/**
 * - rotation pricing (full, pole)
 * - size pricing (x,y,z size)
 * - theme (user content, custom pricing for each)
 * - table (user content, custom pricing for each)
 * - ring (user content, custom pricing for each, should be 4 types)
 * - control (manual, app)
 * - 230V power supply (true/false)
 */
export const useStore = create(updateURL(
    (set, get) => ({
        rotation: "",
        size: "",
        theme: "",
        table: "",
        ring: "",
        control: "",
        powerSupply: false,
        language: "en",
        translations,
        setLanguage: (language) => set({ language }),
        setRotation: (rotation) => set({ rotation }),
        setSize: (size) => set({ size, theme: "", ring: "", table: "" }),
        setTheme: (theme) => set({ theme }),
        setTable: (table) => set({ table }),
        setRing: (ring) => set({ ring }),
        setControl: (control) => set({ control }),
        setPowerSupply: (powerSupply) => set({ powerSupply }),
        reset: () => set({
            rotation: "",
            size: "",
            theme: "",
            table: "",
            ring: "",
            control: "",
            powerSupply: false,
            stepsFinished: 0,
        }),
        preload: (initialState) => set({
            rotation: initialState.rotation || get().rotation,
            size: initialState.size || get().size,
            theme: initialState.theme || get().theme,
            table: initialState.table || get().table,
            ring: initialState.ring || get().ring,
            control: initialState.control || get().control,
            powerSupply: initialState.powerSupply || get().powerSupply,
            stepsFinished: initialState.stepsFinished || get().stepsFinished,
            translations: initialState.translations || get().translations,
        })
    })
  ))